
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {Getter} from "vuex-class";
import { SCOPED_GROUP_PREFIX, ODM_DEFAULT_USER_GROUP_PREFIX, ADMIN_MYLOBY_GROUP_NAME } from "@/utils/constants";

@Component
export default class UserGroupEdit extends Vue {
    @Prop({})
    public group: {
        id: number,
        name: string,
        description: string,
        type: string,
        Users: any[],
        scope: string,
    };

    @Prop({ default: false })
    public displayDialog: boolean;

    @Prop({default: null})
    public companyId: number;

    @Getter private canDoInEnvCompany: (right: string) => boolean;

    private selectedUsers: any[] = [];
    private users: any[] = [];
    private loadingDelete: boolean = false;
    private loadingSave: boolean = false;
    private userGroupSearch: string = "";
    private userGroupSelectable: any = [];
    private defaultForMissionOrder: boolean = false;
    private scoped: boolean = false;
    private groupName: string = "";
    private ODM_DEFAULT_USER_GROUP_PREFIX = ODM_DEFAULT_USER_GROUP_PREFIX;
    private SCOPED_GROUP_PREFIX = SCOPED_GROUP_PREFIX;

    get isProtectedGroup(): boolean {
        return this.group?.name === ADMIN_MYLOBY_GROUP_NAME;
    }

    @Watch("userGroupSearch")
    public handlerSearch(): void {
        this.getSelectableUserGroup();
    }

    private mounted(): void {
        this.selectedUsers = this.selectableUsers(this.group.Users);
        this.groupName = this.group.name;
        this.defaultForMissionOrder = this.groupName.includes(ODM_DEFAULT_USER_GROUP_PREFIX);
        this.scoped = this.groupName.includes(SCOPED_GROUP_PREFIX);
        this.groupName = this.groupName
        .replace(ODM_DEFAULT_USER_GROUP_PREFIX, "")
        .replace(SCOPED_GROUP_PREFIX, "");
            }

    private updateUserGroup() {
        this.loadingSave = true;
        const userGroup = { ...this.group };
        const oldUsers: number[] = userGroup.Users.map((k: any) => k.id);
        const newUsers: number[] = this.selectedUsers.map((k: any) => k.value.id);
        const addUsers: number[] = this.selectedUsers
            .filter((item) => !oldUsers.includes(item.value.id))
            .map((k: any) => k.value.id);
        const removeUsers: any[] = oldUsers.filter((item) => !newUsers.includes(item));
        userGroup.name = this.defaultForMissionOrder
          ? ODM_DEFAULT_USER_GROUP_PREFIX + this.groupName
          : this.groupName;
        this.$store.dispatch("userGroups/update", {
            groupId: this.group.id,
            addUsers,
            removeUsers,
            userGroup,
        }).then((res) => {
            this.closeEdit();
            this.$store.commit("alerts/displaySuccess", {
                msg : this.$i18n.t("actions.saved"),
            });
        }).catch((error) => {
            this.$store.commit("alerts/displayHttpError", { error });
        }).finally(() => {
            this.loadingSave = false;
        });
    }

    private deleteUserGroup(): void {
        this.loadingDelete = true;
        if (confirm(String(this.$t("userGroup.deleteConfirmation")))) {
            this.$store.dispatch("userGroups/deleteById", {
              id: this.group.id,
            }).then((res) => {
                this.$emit("back");
            }).catch((error) => {
                this.$store.commit("alerts/displayHttpError", { error });
            }).finally(() => {
                this.loadingDelete = false;
            });
        } else {
            this.loadingDelete = false;
        }
    }

    private selectableUsers(users: any[]): any[] {
        return users?.map((user: any) => ({ text: user.displayName, value: user, ...user }));
    }

    private removeDuplicates(completeList, duplicates): any[] {
        return completeList.filter((item: any) =>
            !duplicates.map((elem: any) => elem?.id)?.includes(item?.id));
    }

    private closeEdit(): void {
        this.selectedUsers = [];
        this.$emit("reset");
    }

    private getSelectableUserGroup(): void {
        if (this.group.type === "contacts") {
            if (!this.canDoInEnvCompany("READ_CONTACTS")) {
              return this.$store.commit("alerts/displayError", {
                msg: this.$t("alerts.error.cantFetchUsers"),
              });
            }
            this.$store.dispatch("companies/getContacts", {
                id: this.companyId,
                query: {
                    search: this.userGroupSearch,
                },
            }).then((res) => this.userGroupSelectable = res.users.filter(Boolean).map((u) => ({
                    text: u.Contact?.displayName || u.displayName,
                    value: u,
                    ...u,
                }),
            ));
        } else {
            if (!this.canDoInEnvCompany("READ_SUBORDINATES")) {
              return this.$store.commit("alerts/displayError", {
                msg: this.$t("alerts.error.cantFetchUsers"),
              });
            }
            this.$store.dispatch("companies/getSubordinates", {
                id: this.companyId,
                query: {
                    search: this.userGroupSearch,
                },
            }).then((res) => this.userGroupSelectable = res.users.filter(Boolean).map((u) => ({
                    text: u.Contact?.displayName || u.displayName,
                    value: u,
                    ...u,
                }),
            ));
        }
    }
}
